var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuxembourg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 36,
    viewBox: "0 0 51 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_245_88188)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.475586,
    y: -0.000976562,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.475586 23.999H50.8756V35.999H0.475586V23.999Z",
    fill: "#1E448D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.475586 -0.000976562H50.8756V11.999H0.475586V-0.000976562Z",
    fill: "#B01923"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_245_88188"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.475586,
    y: -0.000976562,
    width: 50.4,
    height: 36,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuxembourg);
export default __webpack_public_path__ + "static/media/Luxembourg.7f5290ba5ecbd8e6ad31715402d9f74a.svg";
export { ForwardRef as ReactComponent };